// An object id names one object in every preset that carries it (a pin, its carry and the cascade match by id), so a new object never takes an id another preset may hold.
const DIGITS = '0123456789abcdefghijklmnopqrstuvwxyz'

/** A fresh `<type>_<8 base-36>` id, free in `objects`. */
export const newObjectId = (type, objects) => {
	for (;;) {
		let tail = ''
		for (const b of crypto.getRandomValues(new Uint8Array(8))) tail += DIGITS[b % 36]
		const id = `${type}_${tail}`
		if (!objects?.[id]) return id
	}
}
